
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { TrainingFormValues } from '../../../types';

interface NotesSectionProps {
  form: UseFormReturn<TrainingFormValues>;
}

export const NotesSection: React.FC<NotesSectionProps> = ({ form }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Session Reflection</h3>
      
      <FormField
        control={form.control}
        name="learned"
        render={({ field }) => (
          <FormItem>
            <FormLabel>What did I learn?</FormLabel>
            <FormControl>
              <Textarea
                placeholder="What new techniques or concepts did you learn in this session?"
                className="min-h-[80px] resize-y"
                {...field}
                value={field.value || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="improvements"
        render={({ field }) => (
          <FormItem>
            <FormLabel>What can I improve on?</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Which areas need more work or practice?"
                className="min-h-[80px] resize-y"
                {...field}
                value={field.value || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="successes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>What went well today?</FormLabel>
            <FormControl>
              <Textarea
                placeholder="What techniques or strategies were you successful with?"
                className="min-h-[80px] resize-y"
                {...field}
                value={field.value || ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
